<script setup>
import { WdsLinkupsCollapsible } from '@wds/components';

defineProps({
  location: {
    type: Object,
    required: true,
  },
  citySocialCuesCount: {
    type: Number,
    required: false,
    default: null,
  },
});
const { $tracking } = useNuxtApp();
const testingStore = useTestingStore();
const isLinkupsCollapsed = ref(true);

const experimentSocialCuesCityBlock = testingStore.hasEnabledFeature('web_socialCuesCalloutsCityBlock');

const avatarUrls = [
  'https://a.hwstatic.com/image/upload/h_42,w_42,f_auto,q_auto/v1731581136/pwa/whosgoing1.png',
  'https://a.hwstatic.com/image/upload/h_42,w_42,f_auto,q_auto/v1731581136/pwa/whosgoing2.png',
  'https://a.hwstatic.com/image/upload/h_42,w_42,f_auto,q_auto/v1731581136/pwa/whosgoing3.png',
];

function toggleLinkupsCollapse() {
  const trackingInfo = {
    segment: {
      action: isLinkupsCollapsed.value ? 'Social Cues Block Expanded' : 'Social Cues Block Closed',
      social_cues_web_block_cohort: experimentSocialCuesCityBlock ? 'variation' : 'control',
      social_cues_block_flag: !!experimentSocialCuesCityBlock,
    },
  };
  $tracking.onTrackEvent(trackingInfo.segment);
  isLinkupsCollapsed.value = !isLinkupsCollapsed.value;
}
</script>

<template>
  <div
    v-if="experimentSocialCuesCityBlock"
    class="linkups"
  >
    <WdsLinkupsCollapsible
      :collapsed="isLinkupsCollapsed"
      @collapsed-state="toggleLinkupsCollapse"
    >
      <template #collapsible-header>
        <div class="linkups-header">
          <div class="rounded-avatar-list">
            <div
              v-for="(avatar, index) in avatarUrls"
              :key="index"
              class="avatar"
            >
              <img
                :src="avatar"
                alt="avatar"
              />
            </div>
          </div>
          <div class="text-header">
            <span class="body-2-reg">{{ $t('t_HOSTELWORLDAPPEXCLUSIVES') }}</span>
            <span class="body-2-bld">{{
              citySocialCuesCount
                ? $t('t_PEOPLEGOINGTO', { NPEOPLE: citySocialCuesCount, CITY: location?.name })
                : $t('t_WHOISSTAYINGWITHYOU')
            }}</span>
          </div>
        </div>
      </template>
      <template #collapsible-body>
        <div class="collapsible-body">
          <span class="body-2-bld">{{ $t('t_MEETTHEMINTHEAPP') }}</span>
          <span class="body-2-reg">{{ $t('t_BOOKNOWTOBOOK', { CITY: location?.name }) }}</span>
        </div>
      </template>
    </WdsLinkupsCollapsible>
  </div>
</template>

<style lang="scss" scoped>
.linkups {
  margin: $wds-spacing-s 0;

  .linkups-header {
    display: flex;

    .rounded-avatar-list {
      display: flex;
      position: relative;
      margin: 0 $wds-spacing-s 0 $wds-spacing-xs;

      .avatar {
        width: wds-rem(42px);
        height: wds-rem(42px);
        border-radius: 50%;
        overflow: hidden;
        border: wds-rem(1px) solid $wds-color-white;
        margin-left: wds-rem(-21px);
      }

      .avatar img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .avatar:first-child {
        margin-left: 0;
      }
    }

    .text-header {
      display: flex;
      flex-direction: column;
    }
  }

  .collapsible-body {
    display: flex !important;
    padding: $wds-spacing-m;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background: rgb(255 255 255 / 38%);
    border-radius: $wds-border-radius-m;
    color: $wds-color-purple;

    span {
      text-align: center;
    }
  }
}
</style>
